exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview .transcodeSwitcher[data-v-a504459e]{background-color:rgba(44,44,84,.8);color:#fff;border-radius:3px;padding:3px 5px;position:absolute;z-index:2;top:15px;left:15px;font-size:12px;line-height:14px;text-transform:uppercase;cursor:pointer}.details[data-v-a504459e]{padding:20px;font-size:18px;list-style:circle}.details li[data-v-a504459e]{margin-bottom:10px}", ""]);

// exports
